import React, { FunctionComponent, memo, ReactElement, useCallback, useContext } from 'react'

import PortraitWidget from './PortraitWidget/PortraitWidget'
import BarChartWidget from './BarChartWidget/BarChartWidget'
import { SurveyContext } from '@context/SurveyContext'
import { SurveyStep } from '@models/Survey/SurveyStep'
import './ResultWidget.scss'

export enum Widgets {
  Portrait,
  Prediction,
  Evolution,
}

function ResultWidget() {
  const { step, currentQuestion } = useContext(SurveyContext)

  const isBarChartStep = [
    SurveyStep.Prediction,
    SurveyStep.Rectify,
    SurveyStep.Probability,
    SurveyStep.Forecasting,
    SurveyStep.Results,
  ].includes(step)

  return (
    <div key="ResultWidget" className="ResultWidget">
      {isBarChartStep && <BarChartWidget key="BarChartWidget" />}
      <PortraitWidget currentQuestion={currentQuestion} hidden={isBarChartStep} key="PortraitWidget" />
    </div>
  )
}

export default memo(ResultWidget)
